/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map } from 'rxjs/operators';
import { from } from 'rxjs';

import { BackendService } from '../../../../../utils/src/lib/sysque-backend/backend.service';
import { CurateSearchService } from '../../../../../utils/src/lib/sysque-backend/curate-search.service';
import {
  GetResultInformationFromTreeViewFolder,
  GetResultInformationFromTreeViewFolderSuccess,
  GetTreeViewRootDirectory,
  GetTreeViewRootDirectorySucces,
} from './fitting-tree-view-actions';

@Injectable()
export class FittingTreeViewEffects {
  constructor(
    private readonly actions$: Actions,
    private backendService: BackendService,
    private curateSearchService: CurateSearchService
  ) {}

  getResultInformationFromTreeViewFolderItemsAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetResultInformationFromTreeViewFolder),
      concatMap(({ treeViewItems }) =>
        from(this.curateSearchService.getResultInformationFromTreeViewFolderItems(treeViewItems)).pipe(
          map(resultInformation => GetResultInformationFromTreeViewFolderSuccess({ resultInformation }))
        )
      )
    )
  );

  getTreeViewRootDirectory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetTreeViewRootDirectory),
      concatMap(() =>
        this.backendService
          .getTreeViewRootDirectory()
          .pipe(map(response => GetTreeViewRootDirectorySucces({ response })))
      )
    )
  );
}
